import store from '@/store'

// 类型
const postType = (post) => {
  if (!post.type) {
    return
  }
  const types = { ASK: '问吧', MOMENT: '友趣', 12345: '全民拍', REPORT: '找记者', NEIGHBOR: '友邻' }
  const type = types[post.type] ? types[post.type] : ''
  return type
}
/* eslint-disable no-undef */
export const qtDownload = (item, query, type) => {
  if (qaplus) {
    const pages = ['帖子详情页', '友圈页', '话题页', '话题页', '帖子详情页', '帖子详情页', '帖子详情页', '友圈页', '话题页']
    const current_page_name = pages.length > type ? pages[type] : '佛山街页面'
    let content_type = ''
    const post = store.state.post
    if (post.id) {
      if (post.videos.length > 0) {
        content_type = '视频'
      } else if (post.images.length > 0) {
        content_type = '图文'
      } else {
        content_type = '文字'
      }
    }
    qaplus.event.record('open_app_clk', 2101, {
      page_name: 'common_page',
      page_title: '公共事件',
      current_page_name, //当前页面名称
      is_install: '不能判断', // 是否安装
      content_code: item.id, // 内容id
      content_title: item.title, // 内容主题
      content_type, // 内容类型
      inviter_id: query && query.memberId ? query.memberId : '' //分享人id
    })
  }
}

// 评论
export const qtComment = (post) => {
  if (qaplus) {
    qaplus.event.record('comment_clk', 2101, {
      page_name: 'common_page',
      page_title: '公共事件',
      current_page_name: '友圈页', //当前页面名称
      author_name: post.memberNickname,
      content_code: post.id, // 内容id
      content_title: post.content, // 内容主题
      content_first_type: '帖子',
      content_second_type: postType(post)
    })
  }
}

// 点赞
export const qtLike = (post) => {
  if (qaplus) {
    qaplus.event.record('thumb_up_clk', 2101, {
      page_name: 'common_page',
      page_title: '公共事件',
      current_page_name: '友圈页', //当前页面名称
      author_name: post.memberNickname,
      content_code: post.id, // 内容id
      content_title: post.content, // 内容主题
      content_first_type: '帖子',
      content_second_type: postType(post)
    })
  }
}
